import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const StillPicker = styled(Grid)(({ theme }) => ({})) as typeof Grid;
